import React from 'react';
import UploadDropArea from './UploadDropArea';
import FileList from './FileList';
import {withStyles} from '@material-ui/core/styles';
import styles from './UploadContainer.css';

function UploadContainer(props){

        const {classes, files} = props;
        return (
            <div className={classes.UploadContainer}>
                <UploadDropArea 
                    updateFilesList={props.updateFilesList} 
                    editable={props.editable}
                    popupWarningSnackBar={props.popupWarningSnackBar}
                />

                {
                    ( files.length>0 ) && 
                    <FileList 
                        files={files} 
                        clearFilesList={props.clearFilesList}
                        removeFileFromList={props.removeFileFromList}
                        editable={props.editable}
                        cellSize={props.cellSize}
                        changeCellSize={props.changeCellSize}
                    />
                }

            </div>
        );
}

export default withStyles(styles, {withTheme: true})(UploadContainer);